import axios from 'axios';

export const getSiteContactList = (
  construct_sub: string,
  construct_code: string,
  user_id: number,
  construct_from_date: string,
  construct_end_date: string,
  meetup_time: string,
  work_company: string,
  submission_date: string,
  prefecture_name: string,
  address: string,
  current_page: number,
  display_limit: number,
  sort_direction: string | null,
  sort_field: string | null
) => {
  return axios
    .get(`/api/v1/site_contacts`, {
      params: {
        construct_sub,
        construct_code,
        user_id,
        construct_from_date,
        construct_end_date,
        meetup_time,
        work_company,
        submission_date,
        prefecture_name,
        address,
        page: current_page,
        display_limit,
        sort_direction,
        sort_field
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteSiteContactList = (site_contacts_list: any) => {
  return axios
    .post(
      `/api/v1/delete/site_contacts`,
      {
        site_contacts_list: site_contacts_list
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteSingleSiteContact = (id: number) => {
  return axios
    .delete(`/api/v1/site_contacts/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createSiteContact = (
  id: number, // construct_id
  user_id: number,
  foreman: string,
  site_contact_remarks: string,
  construct_date: string,
  meetup_time: string,
  work_company: string,
  site_supervizor: string,
  site_supervizor_tel: string,
  contact_note: string,
  submission_date: string,
  items: any,
  estimate_id: any
) => {
  return axios
    .post(
      `/api/v1/site_contacts/${id}`,
      {
        user_id,
        foreman,
        site_contact_remarks,
        construct_date,
        meetup_time,
        work_company,
        site_supervizor,
        site_supervizor_tel,
        contact_note,
        submission_date,
        items
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getSiteContactDetails = (id: number) => {
  return axios
    .get(`/api/v1/site_contacts/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateSiteContact = (
  id: number,
  user_id: number,
  foreman: string,
  site_contact_remarks: string,
  construct_date: string,
  meetup_time: string,
  work_company: string,
  site_supervizor: string,
  site_supervizor_tel: string,
  contact_note: string,
  submission_date: string,
  items: any
) => {
  return axios
    .put(
      `/api/v1/site_contacts/${id}`,
      {
        user_id,
        foreman,
        site_contact_remarks,
        construct_date,
        meetup_time,
        work_company,
        site_supervizor,
        site_supervizor_tel,
        contact_note,
        submission_date,
        items
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const copySiteContacts = (
  site_contact_id: number,
  construct_id: number
) => {
  return axios
    .post(
      `/api/v1/copy/site_contacts/${site_contact_id}`,
      { construct_id },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getExportSiteContactsItems = (
  selected_columns: any,
  construct_sub: string,
  user_id: number,
  meetup_time: string,
  work_company: string,
  submission_date: string,
  construct_from_date: string,
  construct_end_date: string,
  prefecture_name: string,
  address: string
) => {
  return axios
    .post(
      `/api/v1/export/site_contacts/list?construct_sub=${construct_sub}&user_id=${user_id}&work_company=${work_company}&construct_from_date=${construct_from_date}&construct_end_date=${construct_end_date}&submission_date=${submission_date}&prefecture_name=${prefecture_name}&address=${address}`,
      {
        selected_columns
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getSiteContactExportDetails = (id: number) => {
  return axios
    .get(`/api/v1/export/site_contact/${id}/details`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createSiteContactFromDocument = (enc_data: string) => {
  return axios
    .post(
      `/api/v1/import/site_contact/document`,
      {
        enc_data
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
